import { useState } from 'react';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import AntivirusTab from './AntivirusTab';
import CidrAddressTab from './CidrAddressTab';
import DeletionTab from './DeletionTab';
import InstanceSettingsTab from './InstanceSettingsTab';
import { INSTANCE_STATE } from '../../../apis/constants';
import {
  INSTANCE_CATEGORY,
  MAX_STANDARD_CIDRS_LIMIT,
} from '../../../constants';
import { isGPSInstance, isSolrInstance } from '../../../utils/utils';

const SettingsTabs = ({
  instance,
  onDeleteInstance,
  onRemoveImage,
  onUpdateCidrs,
  onUpdateInstance,
}) => {
  const { t } = useTranslation('sectionTitles');

  const [tab, setTab] = useState(0);
  const handleTabChange = (event, newTab) => setTab(newTab);

  const maxCidrLimit =
    instance.category === INSTANCE_CATEGORY.ENTERPRISE
      ? instance.cidrCount
      : MAX_STANDARD_CIDRS_LIMIT[instance.instances[0].type] || 0;

  const instanceBusy = instance.status !== INSTANCE_STATE.RUNNING;

  const isSolrOrGps =
    isSolrInstance(instance.clusterType) || isGPSInstance(instance.clusterType);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 0 }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          aria-label="settings tabs"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor:
                tab === 3
                  ? (theme) => theme.palette.error.light
                  : (theme) => theme.palette.primary.main,
            },
          }}
        >
          <Tab value={0} label={t('settings.instance')} />
          {isSolrOrGps && <Tab value={1} label={t('settings.cidr')} />}
          {isSolrOrGps && <Tab value={2} label={t('settings.virusScan')} />}
          <Tab
            label={t('settings.delete')}
            sx={{
              color: (theme) => theme.palette.error.light,
              '&.Mui-selected': {
                color: (theme) => theme.palette.error.light,
              },
            }}
            value={3}
          />
        </Tabs>
      </Box>
      <Box>
        {tab === 0 && (
          <InstanceSettingsTab
            instance={instance}
            onRemoveImage={onRemoveImage}
            onUpdateInstance={onUpdateInstance}
          />
        )}
        {tab === 1 && (
          <CidrAddressTab
            instance={instance}
            instanceBusy={instanceBusy}
            maxCidrLimit={maxCidrLimit}
            onUpdateCidrs={onUpdateCidrs}
          />
        )}
        {tab === 2 && (
          <AntivirusTab instanceSize={instance.instances[0].type} />
        )}
        {tab === 3 && (
          <DeletionTab
            instance={instance}
            onDeleteInstance={onDeleteInstance}
          />
        )}
      </Box>
    </Box>
  );
};

SettingsTabs.propTypes = {
  instance: PropTypes.object.isRequired,
  onDeleteInstance: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  onUpdateCidrs: PropTypes.func,
  onUpdateInstance: PropTypes.func.isRequired,
};

export default SettingsTabs;
